import { ready } from '~/core'

ready('timeLine', '.timeLine', (timeLine) => {
  const items = timeLine.querySelectorAll('.timeLine-item')
  const scrollPoint = window.innerHeight / 4
  window.addEventListener('scroll', (event) => {
    items.forEach((item) => {
      let itemSize = item.getBoundingClientRect()
      let itemTop = itemSize.top
      let itemBottom = itemSize.bottom
      if (itemTop <= scrollPoint && itemBottom >= scrollPoint) {
        item.classList.add('is-scrolled')
      } else {
        item.classList.remove('is-scrolled')
      }
    })
  })
})
